/* eslint-disable react-hooks/exhaustive-deps */
import { __ } from "src/libs/utilities"
import { ContactFormContent, LANDING_TYPE_CONTENT, OVERLAY_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import "../../../assets/css/cf.scss"
import { IPrimitiveProps } from "../section/Primitive"
import { ContactFormLayout } from "./contact-form/ContactFormLayout"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { Intent, Position, Tooltip } from "@blueprintjs/core"

/* Protopia Ecosystem component */

const ContactFormPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const  isEdit = useLandingStore((state: ILandingStore) => state.isEdit)
    const primitive: ContactFormContent = ( props.primitive || {} ) as ContactFormContent
    if( !!primitive.overlayType && primitive.overlayType !== OVERLAY_TYPE.INLINE ) {
        return isEdit
            ?
            <Tooltip
                intent={ Intent.PRIMARY }
                position={ Position.TOP_LEFT }
                compact
                content={ <div className="small letter-spacing-2">{ __( components()[ primitive.type ].title ) }</div> }
            >
                <div className="icon-square bg-light m-1 pointer user-select-none" data-select-type="ignore">
                    <img 
                        src={components()[LANDING_TYPE_CONTENT.CONTACT_FORM].icon}
                        height={ 14 }
                        alt=""
                    />
                </div>
            </Tooltip>
            : 
            <></>
    }
    return <ContactFormLayout {...props} />
    
}
export default ContactFormPrimitive
 
